import { AfterViewInit, Component, Injectable, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { GlobalDataService } from '../services/global-data.service';
import { SessionService } from '../services/session.service';
import { StringHelpers } from '../helpers/string-helpers';

@Injectable()
@Component({
    selector: 'outing-outingiteration-select',
    templateUrl: './outing-outingiteration-select.component.html',
    styleUrls: ['./outing-outingiteration-select.component.scss'],
    standalone: false
})
export class OutingOutingIterationSelectComponent extends BaseComponent implements OnInit, AfterViewInit {
  public outings: any = [];
  
  constructor(public sessionService: SessionService,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.globalDataService.postDashboardLoadEvent.subscribe(outingAndIterations => {
      this.isLoading = true;
      this.outings = outingAndIterations;
      if(this.isGlobalOutingSet()){
        this.selectedOuting = this.getGlobalOuting();
        this.selectedIteration = this.getGlobalOutingIteration();
      }
      
      this.isLoading = false;
    });
  }

  onOutingSelection() {
    this.setGlobalOuting(this.selectedOuting);
    this.globalDataService.outingSelectionEvent.emit(this.selectedOuting);
  }

  onIterationSelection() {
    this.setGlobalOutingIteration(this.selectedIteration);
    this.globalDataService.iterationSelectionEvent.emit(this.selectedIteration);
  }
}
